module.exports = __webpack_public_path__ + "img/huaban.1615bd32.png";